<template>
  <div>
    <div class="background"></div>
    <div class="dialog">
      <div class="mainContent">
        <p class="close">
          <span class="closeButton" @click="onClose">✖</span>
        </p>
        <div class="title">パスワードの再登録</div>
        <div v-show="!isSendMailSuccess">
          <p class="error">{{ errorMessage }}</p>
          <InputMailAddress @input="changeMailAddress" />
          <ButtonTextLink
            class="button"
            @click-text="onClickCheckMailAddress"
            text="問い合わせる"
          />
        </div>
        <div class="mainContent" v-show="isSendMailSuccess">
          <p>
            登録されていた場合、入力されたメールアドレスにパスワードをお送りしました。
          </p>
          <TextLink @click="onClickSignin" text="ログイン画面に戻る" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import InputMailAddress from "@/components/Input/InputMailAddress";
import TextLink from "@/components/Text/TextLink";
import Firebase from "./../../firebase";
import ButtonTextLink from "@/components/Atoms/ButtonTextLink";

export default {
  name: "forgot-password-modal",
  components: {
    TextLink,
    InputMailAddress,
    ButtonTextLink,
  },
  data() {
    return {
      mailadress: undefined,
      errorMessage: undefined,
      isLoading: false,
      isSendMailSuccess: false,
    };
  },
  methods: {
    ...mapMutations(["loadingStartMini", "loadingEndMini", "setModal"]),
    changeMailAddress(value) {
      this.mailadress = value.value;
    },
    onClickSignin() {
      this.setModal("signin");
    },
    async onClickCheckMailAddress() {
      this.loadingStartMini();

      await Firebase.sendPasswordResetEmail(this.mailadress)
        .then(() => {
          this.loadingEndMini();
          this.isSendMailSuccess = true;
        })
        .catch((result) => {
          if (result === "auth/user-not-found") {
            this.errorMessage = "メールアドレスが登録されていません";
          }
          this.loadingEndMini();
        });
    },
    onClose() {
      this.setModal("");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";
.mainContent {
  padding: 0 8px;
  .error {
    text-align: center;
    color: #ff7c86;
  }
}
.bottom {
  margin-top: 5vh;
  padding-top: 2vh;
}

.close {
  text-align: right;
  margin: 0;
  .closeButton {
    width: 24px;
    height: 24px;
    cursor: pointer;
  }
}
.button {
  width: 70vw;
}

.title {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 1rem;
  text-align: center;
}
.background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}
.dialog {
  position: fixed;
  display: flex;
  flex-direction: column;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-55%);
  background-color: white;
  z-index: 1001;
  width: 80vw;
  padding: 1rem;
  border-radius: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/ForgotPasswordModal.vue